module.exports = __webpack_public_path__ + "static/media/buttonProduct_contact.22991afb.png";